import { Box, Typography, TypographyProps } from '@mui/material';
import { Trans } from 'react-i18next';

interface ModalPageTitleProps {
  title: string;
  titleLabel?: string;
  subtitle?: string;
  sx?: TypographyProps['sx'];
  onClick?: () => void; // <- nova prop opcional
}

export default function PageTitle(props: ModalPageTitleProps) {
  const { title, titleLabel, subtitle, sx, onClick } = props;
  return (
    <Box sx={{ mb: 4, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
        <Typography sx={{ cursor: onClick ? 'pointer' : 'default', ...sx }} variant="h1" onClick={onClick}>
          {title}
        </Typography>
        <Typography sx={{ ml: 0.5 }} variant="subtitle2">
          {titleLabel}
        </Typography>
      </Box>
      {subtitle && (
        <>
          <Box sx={{ mb: 0.5 }} />
          <Box>
            <Trans>
              <Typography variant="subtitle2">{subtitle}</Typography>
            </Trans>
          </Box>
        </>
      )}
    </Box>
  );
}
